"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var paymentRatesStyles_1 = require("./paymentRatesStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var IndicativeNumber_1 = require("../../../../common/components/indicativeNumber/IndicativeNumber");
var PercentageLabelValue = function (_a) {
    var percentageData = _a.percentageData, percentageLabel = _a.percentageLabel, _b = _a.className, className = _b === void 0 ? '' : _b, indicativeNumber = _a.indicativeNumber, _c = _a.dataTest, dataTest = _c === void 0 ? '' : _c;
    var _d = paymentRatesStyles_1.default(), paymentRatesPercentageValue = _d.paymentRatesPercentageValue, paymentRatesPercentageLabel = _d.paymentRatesPercentageLabel, paymentRatesPercentageGroup = _d.paymentRatesPercentageGroup;
    return (<core_1.Grid item={true} xs={6} className={clsx_1.default([paymentRatesPercentageGroup, className])} data-test={dataTest || 'calculator:percentage-label-value'}>
      <core_1.Box display="flex" alignItems="center">
        <core_1.Typography component="h2" className={paymentRatesPercentageValue}>
          {percentageData.value}
          {percentageData.title && (<Translation_1.default className={percentageData.titleClassName} id={percentageData.title} values={percentageData.titleValues || undefined}/>)}
          <IndicativeNumber_1.default value={indicativeNumber}/>
        </core_1.Typography>
      </core_1.Box>
      {percentageLabel && (<core_1.Box display="flex" alignItems="baseline">
          <core_1.Typography component="h2" className={paymentRatesPercentageLabel}>
            <Translation_1.default id={percentageLabel.title} values={percentageLabel.titleValues || undefined}/>
          </core_1.Typography>
        </core_1.Box>)}
    </core_1.Grid>);
};
exports.default = PercentageLabelValue;
